import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DropdownMenu, DropdownMenuItem, DropdownMenuLabel } from "@air/primitive-dropdown-menu";
import Router from "next/router";
import pluralize from "pluralize";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { BoardThumbnail } from "~/components/Discussions/DiscussionsMenu/components/BoardThumbnail";
import { CommentCount } from "~/components/Discussions/DiscussionsMenu/components/CommentCount";
import { DiscussionsLibraryMenuItem } from "~/components/Discussions/DiscussionsMenu/components/DiscussionsLibraryMenuItem";
import { DiscussionsMenuItem } from "~/components/Discussions/DiscussionsMenu/components/DiscussionsMenuItem";
import { createAllContentAssetRoute } from "~/constants/routes";
import { useGoToBoardAssetPage } from "~/hooks/useGoToBoardAssetPage";
import { centralizedClipBoardInfoSelector, centralizedClipSelector } from "~/store/centralizedClip/selectors";
export const DiscussionsMenu = (param)=>{
    let { trigger } = param;
    const asset = useSelector(centralizedClipSelector);
    const { current, others } = useSelector(centralizedClipBoardInfoSelector);
    const { goToBoardAssetPage } = useGoToBoardAssetPage();
    const libraryMenuItem = useMemo(()=>{
        return /*#__PURE__*/ _jsx(DropdownMenuItem, {
            onClick: ()=>Router.push(createAllContentAssetRoute(asset.id)),
            children: /*#__PURE__*/ _jsx(DiscussionsLibraryMenuItem, {})
        });
    }, [
        asset.id
    ]);
    return /*#__PURE__*/ _jsxs(DropdownMenu, {
        className: "w-[376px]",
        trigger: trigger,
        size: "large",
        children: [
            /*#__PURE__*/ _jsx(DropdownMenuLabel, {
                children: "Current location"
            }),
            current ? /*#__PURE__*/ _jsx(DropdownMenuItem, {
                disabled: true,
                onClick: ()=>goToBoardAssetPage({
                        board: current,
                        asset
                    }),
                children: /*#__PURE__*/ _jsx(DiscussionsMenuItem, {
                    adornmentRight: /*#__PURE__*/ _jsx(CommentCount, {
                        count: current.openCommentCount
                    }),
                    title: current.title,
                    thumbnail: /*#__PURE__*/ _jsx(BoardThumbnail, {
                        thumbnails: current.thumbnails
                    })
                })
            }) : libraryMenuItem,
            others.length > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs(DropdownMenuLabel, {
                        children: [
                            "Appears in ",
                            others.length,
                            " other ",
                            pluralize("location", others.length)
                        ]
                    }),
                    others.map((board)=>{
                        return /*#__PURE__*/ _jsx(DropdownMenuItem, {
                            onClick: ()=>goToBoardAssetPage({
                                    board,
                                    asset
                                }),
                            children: /*#__PURE__*/ _jsx(DiscussionsMenuItem, {
                                adornmentRight: /*#__PURE__*/ _jsx(CommentCount, {
                                    count: board.openCommentCount
                                }),
                                ancestors: board.ancestors,
                                thumbnail: /*#__PURE__*/ _jsx(BoardThumbnail, {
                                    thumbnails: board.thumbnails
                                }),
                                title: board.title
                            })
                        }, board.id);
                    })
                ]
            }),
            !!current && libraryMenuItem
        ]
    });
};
